import * as THREE from 'three';

// Process indices for intersection
export const processIndices = (indices, vertices, objCurrent, mathPlane, intersectionPoints) => {
    if (indices !== null) {
        // With indexed geometry
        for (let j = 0; j < indices.count; j += 3) {
            const aIndex = indices.getX(j);
            const bIndex = indices.getX(j + 1);
            const cIndex = indices.getX(j + 2);

            const a = new THREE.Vector3().fromBufferAttribute(vertices, aIndex);
            const b = new THREE.Vector3().fromBufferAttribute(vertices, bIndex);
            const c = new THREE.Vector3().fromBufferAttribute(vertices, cIndex);

            objCurrent.localToWorld(a);
            objCurrent.localToWorld(b);
            objCurrent.localToWorld(c);

            processTriangle(a, b, c, mathPlane, intersectionPoints);
        }
    } else {
        // Non-indexed geometry
        for (let j = 0; j < vertices.count; j += 3) {
            const a = new THREE.Vector3().fromBufferAttribute(vertices, j);
            const b = new THREE.Vector3().fromBufferAttribute(vertices, j + 1);
            const c = new THREE.Vector3().fromBufferAttribute(vertices, j + 2);

            objCurrent.localToWorld(a);
            objCurrent.localToWorld(b);
            objCurrent.localToWorld(c);

            processTriangle(a, b, c, mathPlane, intersectionPoints);
        }
    }
};

// Process triangle for intersection
export const processTriangle = (a, b, c, mathPlane, intersectionPoints) => {
    const lineAB = new THREE.Line3(a, b);
    const lineBC = new THREE.Line3(b, c);
    const lineCA = new THREE.Line3(c, a);

    setPointOfIntersection(lineAB, mathPlane, intersectionPoints);
    setPointOfIntersection(lineBC, mathPlane, intersectionPoints);
    setPointOfIntersection(lineCA, mathPlane, intersectionPoints);
};

// Find intersection point
export const setPointOfIntersection = (line, plane, intersectionPoints) => {
    const pointOfIntersection = new THREE.Vector3();
    if (plane.intersectLine(line, pointOfIntersection)) {
        intersectionPoints.push(pointOfIntersection.clone());
    }
};

// Compute mesh intersection
export const computeMeshIntersection = (indices, vertices, mesh, plane, intersectionPoints) => {
    if (indices !== null) {
        // With indexed geometry
        processIndexedGeometryIntersection(indices, vertices, mesh, plane, intersectionPoints);
    } else {
        // Non-indexed geometry
        processNonIndexedGeometryIntersection(vertices, mesh, plane, intersectionPoints);
    }
};

// Process indexed geometry for mesh intersection
export const processIndexedGeometryIntersection = (indices, vertices, mesh, plane, intersectionPoints) => {
    for (let j = 0; j < indices.count; j += 3) {
        const aIndex = indices.getX(j);
        const bIndex = indices.getX(j + 1);
        const cIndex = indices.getX(j + 2);

        const a = new THREE.Vector3().fromBufferAttribute(vertices, aIndex);
        const b = new THREE.Vector3().fromBufferAttribute(vertices, bIndex);
        const c = new THREE.Vector3().fromBufferAttribute(vertices, cIndex);

        mesh.localToWorld(a);
        mesh.localToWorld(b);
        mesh.localToWorld(c);

        processMeshTriangle(a, b, c, plane, intersectionPoints);
    }
};

// Process non-indexed geometry for mesh intersection
export const processNonIndexedGeometryIntersection = (vertices, mesh, plane, intersectionPoints) => {
    for (let j = 0; j < vertices.count; j += 3) {
        const a = new THREE.Vector3().fromBufferAttribute(vertices, j);
        const b = new THREE.Vector3().fromBufferAttribute(vertices, j + 1);
        const c = new THREE.Vector3().fromBufferAttribute(vertices, j + 2);

        mesh.localToWorld(a);
        mesh.localToWorld(b);
        mesh.localToWorld(c);

        processMeshTriangle(a, b, c, plane, intersectionPoints);
    }
};

// Process triangle for mesh intersection
export const processMeshTriangle = (a, b, c, plane, intersectionPoints) => {
    const lineAB = new THREE.Line3(a, b);
    const lineBC = new THREE.Line3(b, c);
    const lineCA = new THREE.Line3(c, a);

    setPointOfIntersection(lineAB, plane, intersectionPoints);
    setPointOfIntersection(lineBC, plane, intersectionPoints);
    setPointOfIntersection(lineCA, plane, intersectionPoints);
};

// Update plane from mesh geometry
export const updatePlane = (mathPlane, plane) => {
    const vertices = plane.geometry.attributes.position;
    const planePointA = new THREE.Vector3().fromBufferAttribute(vertices, 0);
    const planePointB = new THREE.Vector3().fromBufferAttribute(vertices, 1);
    const planePointC = new THREE.Vector3().fromBufferAttribute(vertices, 2);

    plane.localToWorld(planePointA);
    plane.localToWorld(planePointB);
    plane.localToWorld(planePointC);

    mathPlane.setFromCoplanarPoints(planePointA, planePointB, planePointC);
};